import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "broschure",
  "use": "broschure-usage",
  "viewBox": "0 0 18 23.9",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 23.9\" id=\"broschure\"><path d=\"M18 23.8H0v-1.1h.7l-.1-.3 12.6-3V2.2L9.9 3l-.3-1.1L14.3.7v3.5H18v19.6zM4.4 22.7h12.5V5.4h-2.5v14.9l-10 2.4z\" /><path d=\"M9.5 1.6v16.8l-8.4 3.7V4.9l8.4-3.3zM10.6 0L0 4.1v19.7l10.6-4.7V0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol